import * as http from 'utils/http';
import config from 'config';

const getCarrierProfiles = () => http.get(`${config.API_URL}carrier/profiles/?page_size=0`);
const postDeleteDocument = (docId, data) =>
  http.post(`${config.BASE_URL}/api/dms/document/${docId}/remove/`, data);
const putDocumentExpirationDate = (docId, expiration_date) =>
  http.put(`${config.BASE_URL}/api/dms/documents/${docId}/`, { expiration_date });

export { getCarrierProfiles, postDeleteDocument, putDocumentExpirationDate };
